import { FC } from "react";
import "./style.scss";
import AccOptionIcon from "../../../../assets/AccOptionIcon.svg";
import { ReactComponent as OrderWarningIcon } from "../../../../assets/WarningAcc.svg";
import { SvgIcon } from "static/types";

type PropType = {
  image: SvgIcon;
  option: string;
  onClick?: () => void;
  notification?: boolean;
  svgType?: "fill" | "stroke";
};

export const AccountOptionCard: FC<PropType> = ({
  image: OptionIcon,
  option,
  onClick,
  notification,
  svgType = "fill",
}) => {
  return (
    <div onClick={onClick} className="account-option-card">
      <div>
        <OptionIcon className={`account-option-card-icon-${svgType}`} aria-hidden />
        {notification && (
          <OrderWarningIcon className="option-order-notification-icon" aria-hidden />
        )}
        <p>{option}</p>
      </div>
      <img src={AccOptionIcon} alt="icon-right" />
    </div>
  );
};
